export default class Category {
	constructor(data) {
		this.data = data;
	}

	get name() {
		return this.data.name.replace(" / ", " & ");
	}

	get id() {
		return this.data.id;
	}

	get slug() {
		return this.data.name
			.toLowerCase()
			.trim()
			.replace(/[^a-z0-9]+/g, "-");
	}
}
